import { IfcTypesMap } from './types-map';
export class Properties {
    constructor(api) {
        this.api = api;
    }
    getIfcType(type) {
        return IfcTypesMap[type];
    }
    async getItemProperties(modelID, id, recursive = false) {
        return await this.api.getPassthrough(modelID)?.properties.getItemProperties(id, recursive);
    }
    async getPropertySets(modelID, elementID, recursive = false) {
        return await this.api.getPassthrough(modelID)?.properties.getPropertySets(elementID, recursive);
    }
    async getTypeProperties(modelID, elementID, recursive = false) {
        return await this.api.getPassthrough(modelID)?.properties.getTypeProperties(elementID, recursive);
    }
    async getMaterialsProperties(modelID, elementID, recursive = false) {
        return await this.api.getPassthrough(modelID)?.properties.getMaterialsProperties(elementID, recursive);
    }
    async getSpatialStructure(modelID, includeProperties) {
        return await this.api.getPassthrough(modelID)?.properties.getSpatialStructure(includeProperties);
    }
    async getAllItemsOfType(modelID, type, verbose) {
        return await this.api.getPassthrough(modelID)?.properties.getAllItemsOfType(type, verbose);
    }
}
